import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Platform from './pages/Platform';
import Services from './pages/Services';
import Industries from './pages/Industries';
import Pricing from './pages/Pricing';
import Domain from './pages/Domain';
import LicenseGen from './pages/LicenseGen';

/* The route tree on its own, with no router around it. The browser wraps it in
   a BrowserRouter (below); the build-time prerenderer wraps the same tree in a
   StaticRouter, so both render identical markup. */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Domain />} />
      <Route path="/domain" element={<Domain />} />
      <Route path="/license" element={<LicenseGen />} />

      {/* All public pages share the Navbar and Footer via the Layout component */}
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/platform" element={<Platform />} />
        <Route path="/services" element={<Services />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/pricing" element={<Pricing />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
